<template>
  <div id="BookingConfirmed"
    class="d-flex flex-column align-items-center content-container container-width text text-center animate__animated animate__fadeIn booking-confirm-container border-brand-tertiary">
    <i class="fa fa-circle-check confirm-check"></i>
    <h3 class="dmh-start-title text p-0">
      Booking confirmed!
    </h3>
    <div class="mb-5">
      <div class="text pb-4">
        You should soon receive an email confirming your booking, followed by a reminder email {{ reminderTime }} before
        your appointment to your registered email address.
      </div>
      <div>
        To attend or cancel your session, go to the booking area by clicking the calendar icon in the top navigation.
      </div>
    </div>
    <div v-if="isImportantNoteShown" class="important-note">
      <div class="important-header">
        <p class="important-title">
          <i class="fa fa-exclamation-circle mr-2" aria-hidden="true"></i>
          Important Note
        </p>
        <button @click="hideImportantNote" class="close-button">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <p class="text">
        For both audio appointments and video appointments, you will need to return to the app to join your session at
        the scheduled time.
      </p>
      <p class="text mb-0">
        Clinicians do not call users directly. Ensure you log in a few minutes before your appointment to avoid missing
        your session.
      </p>
    </div>
    <div class="w-100">
      <b-button size="lg" id="return-to-home-button" class="btn-home py-4 px-5 w-100" squared
        @click="returnToHome">Return to Home</b-button>
    </div>
  </div>
</template>

<script>
import EventBus from '@/helpers/eventbus';
import { returnHome } from '@/utils/embed/partnerEmbed';
export default {
  name: "BookingConfirmed",
  data() {
    return {
      isImportantNoteShown: true
    };
  },
  mounted() {
  },
  computed: {
    serviceType() {
      return this.$route.query?.service_type || null;
    },
    reminderTime() {
      return this.serviceType.includes("dmh") ? "the day" : "1 hour";
    }
  },
  methods: {
    hideImportantNote() {
      this.isImportantNoteShown = false;
    },
    returnToHome() {
      returnHome(this.$router, {
        type: "sl:booking-complete",
        v: 1,
        service_type: this.serviceType,
      });
    }
  },
};
</script>

<style lang="less">
#BookingConfirmed {
  .confirm-check {
    font-size: 10rem;
    color: #02b57c;
    margin-bottom: 32px;
  }

  .dmh-start-title {
    text-align: center;
    font-size: 2.2rem;
    letter-spacing: 0;
    font-family: "DMSans Bold";
    padding: 0;
    margin-bottom: 32px;
  }

  .text {
    color: #1E1E22;
  }

  .important-note {
    text-align: left;
    border-radius: 20px;
    background-color: #ffef99;
    padding: 24px;
    margin-bottom: 32px;
  }

  .important-title {
    color: #594b00 !important;
    font-family: "DMSans Bold" !important;
    margin: 0;
  }

  .important-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;

    .fa-times {
      cursor: pointer;
      font-size: 2rem;
    }
  }

  .close-button {
    border: none;
    background-color: unset;
  }

  .btn-home {
    width: 100%;
    color: #fff;
    letter-spacing: normal;
    border: 0;
    background-color: var(--brand-primary);
    border-radius: 10px !important;
    margin: 0 auto;
  }
}
</style>
